const enneagramArray = [
    {
    id: 1,
    type: '1 - Reformer',
    description: 'I am the Rational, Idealistic Type: Principled, Purposeful, Self-Controlled, and Perfectionistic',
    attribute: 'Just',
    connector: 'So God and I both like to be Just!',
    },
    {
        id: 2,
    type: '2 - Helper',
    description: 'I am the Caring, Interpersonal Type: Demonstrative, Generous, People-Pleasing, and Possessive',
    attribute: 'Loving',
    connector: 'So God and I both like to be Loving!',
    },
    {
        id: 3,
    type: '3 - Achiever',
    description: 'I am the Success-Oriented, Pragmatic Type: Adaptive, Excelling, Driven, and Image-Conscious',
    attribute: 'Sovereign',
    connector: 'So God and I both like to be Sovereign!',
    },
    {
        id: 4,
    type: '4 - Individualist',
    description: 'I am the Sensitive, Withdrawn Type: Expressive, Dramatic, Self-Absorbed, and Temperamental',
    attribute: 'Independent',
    connector: 'So God and I both like to be Independent!',
    },
    {
        id: 5,
    type: '5 - Investigator',
    description: 'I am the Intense, Cerebral Type: Perceptive, Innovative, Secretive, and Isolated',
    attribute: 'Omniscient',
    connector: 'So God and I both like to be Omniscient!',
    },
    {
        id: 6,
    type: '6 - Loyalist',
    description: 'I am the Committed, Security-Oriented Type: Engaging, Responsible, Anxious, and Suspicious',
    attribute: 'Faithful',
    connector: 'So God and I both like to be Faithful!',
    },
    {
        id: 7,
    type: '7 - Enthusiast',
    description: 'I am the Busy, Fun-Loving Type: Spontaneous, Versatile, Distractible, and Scattered',
    attribute: 'Omnipresent',
    connector: 'So God and I both like to be Omnipresent!',
    },
    {
        id: 8,
    type: '8 - Challenger',
    description: 'I am the Powerful, Dominating Type: Self-Confident, Decisive, Willful, and Confrontational',
    attribute: 'Omnipotent',
    connector: 'So God and I both like to be Omnipotent!',
    },
    {
        id: 9,
    type: '9 - Peacemaker',
    description: 'I am the Easygoing, Self-Effacing Type: Receptive, Reassuring, Agreeable, and Complacent',
    attribute: 'Peaceful',
    connector: 'So God and I both like to be Peaceful!',
    }
]

export default enneagramArray;